import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=60208f16&"
import script from "./ClientSummary.vue?vue&type=script&lang=ts&"
export * from "./ClientSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports